module.exports = __webpack_public_path__ + "static/media/pharma-benefits-icon-active.a2f7bc64.svg";